import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion,AnimatePresence } from "framer-motion";

function Careers() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
const [selectedPosition, setSelectedPosition] = useState("");
const [loading, setLoading] = useState(false);
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true); // show loading message
  const formData = new FormData();
  formData.append("fullname", document.getElementById("fullname").value);
  formData.append("email", document.getElementById("email").value);
  formData.append("phone", document.getElementById("phone").value);
  formData.append("position", document.getElementById("position").value);
  formData.append("message", document.getElementById("message").value);

  const resumeFile = document.getElementById("resume").files[0];
  if (resumeFile) formData.append("resume", resumeFile);

  try {
    
    const res = await fetch("https://pinakinedgemedia.com/api/sendApplicationMail", {
      method: "POST",
      body: formData, // use FormData for file upload
    });

    const data = await res.json();
    if (data.success) {
      setLoading(false); // show loading message
       setShowSuccessModal(true);  // ✅ This triggers modal to open
      e.target.reset();
      document.getElementById("fileName").textContent = "No file chosen";
    } else {
       setLoading(false); // show loading message
      alert("Error sending application: " + data.error);
    }
  } catch (err) {
    console.error(err);
     setLoading(false); // show loading message
    //alert("Server error, please try again later.");
  }
};


const handleApplyClick = (position) => {
    // Auto-select dropdown when "Apply Now" is clicked
    setSelectedPosition(position);
    // Scroll or open form if needed
    document.getElementById("applyForm")?.scrollIntoView({ behavior: "smooth" });
  };
const [index, setIndex] = useState(0);
 const slides = [
    { text: "Explore. Evolve. Excel — With Pinakinedge Media" },
    { text: "Together, We Build. Together, We Grow" },
    { text: "Your Passion. Our Platform. Endless Possibilities" },
  ];

   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };
  return (
    
    <div>
      <Header />
       <main>
    
 <AnimatePresence>
  {showSuccessModal && (
    <motion.div
      className="modal-overlay show"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <motion.div
        className="modal show"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.3 }}
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "10px",
          width: "400px",
          textAlign: "center",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
        }}
      >
        <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
          Application Sent!
        </h2>
        <p>Thank you for contacting us. We will get back to you shortly.</p>
        <button className="vc rg lk gh ml il hi gi _l"
          onClick={() => setShowSuccessModal(false)}
         
        >
          Close
        </button>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/CareerVideo.mp4"
        autoPlay
        muted
        loading="lazy"
        loop
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>

     <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
      Careers 
        </h2></motion.section>
      </div>
      <br/>
      <div className="container">
        {/* Left Side - Image */}
         <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
        <div className="left">
          <img src="/images/careerimg.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
            <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
          <p className="uo">
            Pinakinedge Media believes that great people build great things. If you’re passionate, innovative, and ready to make an impact, we want you with us. Explore exciting opportunities, grow your skills, and be part of a culture that values creativity, collaboration, and your unique talents. Your next career adventure starts here!</p>
        <h2 className="mk">We Value Our Employees</h2>
         <p>At Pinakinedge Media our people are our greatest strength. We believe in creating a workplace where every employee feels respected, supported, and inspired to do their best work. That’s why we invest in your growth, recognize your contributions, and listen to your ideas. From competitive compensation and meaningful benefits to flexible work arrangements and a strong culture of inclusion—we’re committed to making sure you feel valued every step of the way.</p>
     
     
         </motion.section>
        </div>
      </div>

    </section>
     <section className="i">
          
          {/* Bg Shapes */}
          <span className="rc h s r vd fd/5 fh rm"></span>
         
          <div className="animate_top bb ze rj ki xn vq">
             <motion.section
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="fk vj pr kk wm bb _b">
           Current Job Openings
            </h2>
             <h2 className="ek yj mk gb">Accelerate your career today!</h2>
           </motion.section>
          </div>
    
          {/* Team List */}
          <div className="bb ze i va ki xn jb jo">
               <motion.section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
            <div className="wc qf pn xo gg cp">
         
              <div className="animate_top rj divstyabt2">
                <h4 className="ek yj mk2 gb">Research Analyst</h4>
                <p className="hdse"><b>Full-time • Remote</b></p>
                <p className="hdse">Conduct market research and analysis to support strategic decision-making and campaign development.</p>

                     <button
          className="vc rg lk gh ml il hi gi1 _l"
          onClick={() => handleApplyClick("Research Analyst")}
        >
          Apply Now
        </button>
              </div>
    
    <div className="animate_top rj divstyabt2">
                <h4 className="ek yj mk2 gb">Appointment Generation Executive</h4>
                <p className="hdse"><b>Full-time • Remote</b></p>
                <p className="hdse">
                  We are looking for a results-driven B2B Appointment Generation Executive to generate qualified leads and schedule meetings with decision-makers for our clients. The ideal candidate should have experience in cold outreach, LinkedIn prospecting, and international campaigns.
                   </p>

                     <button
          className="vc rg lk gh ml il hi gi1 _l"
          onClick={() => handleApplyClick("Appointment Generation Executive")}
        >
          Apply Now
        </button>
              </div>
               
            </div>  
            </motion.section>
          </div>
        </section>

        <section id="support" className="i fh rm li">
                   <div className="i va bb ye ki xn wq"  id="applyForm">
                     <div className="tc uf sn tf rn un zf xl:gap-10">
                       <div className="animate_top w-full vk sg hh sm pdten tq mll">
                        <div>
                           <motion.section
                     initial={{ opacity: 0, y: 50 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     viewport={{ once: true, amount: 0.2 }}
                     transition={{ duration: 0.8 }}
                   >
                    <center>
                      <h2 className="fk vj pr kk wm bb _b">
          Apply Now
            </h2>
            <p className="gkl">Fill out the form below to submit your application for the selected position.</p>
            </center>
                           <div className="tc sf yo ap zf xi1 qi">
                             <div className="vd to/2">
                               <label className="rc" htmlFor="fullname">
                                 Full name
                               </label>
                               <input
                                 type="text"
                                 name="fullname"
                                 id="fullname"
                                 className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                               />
                             </div>
             
                            <div className="vd to/2">
                               <label className="rc" htmlFor="phone">
                                 Phone
                               </label>
                              <input
  type="text"
  name="phone"
  id="phone"
  maxLength={10}
  placeholder="Enter Phone Number"
  onChange={(e) => {
    e.target.value = e.target.value.replace(/\D/g, "");
  }}
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

                             </div>
                           </div>
                         <div className="tc sf yo ap zf xi1">
                             <div className="vd to/2">
                               <label className="rc" htmlFor="email">
                               Email
                               </label>
                               <input
                                 type="email"
                                 name="email"
                                 id="email"
                                 className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                               />
                             </div>
                             
             
                            <div className="vd to/2">
  <label className="rc" htmlFor="position">
    Position Applied
  </label>
  <select
          name="position"
          id="position"
          className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1"
          value={selectedPosition}
          onChange={(e) => setSelectedPosition(e.target.value)}
        >
          <option value="">Select Position</option>
          <option value="Research Analyst">Research Analyst</option>
          <option value="Appointment Generation Executive">Appointment Generation Executive</option>
          
        </select>
</div>

                           </div>
                          <div className="fb lb">
  <label className="rc block mb-2" htmlFor="resume">
    Upload Resume (PDF/DOC/DOCX only) *
  </label>

  <div className="relative">
    <input
      type="file"
      id="resume"
      name="resume"
      accept=".pdf,.doc,.docx"
      className="hidden"
      onChange={(e) => {
        const fileName = e.target.files?.[0]?.name || "No file chosen";
        document.getElementById("fileName").textContent = fileName;
      }}
      required
    />
    <label
      htmlFor="resume"
      className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg cursor-pointer hover:bg-blue-700 transition-all duration-200"
    >
      Choose File
    </label>
    <span
      id="fileName"
      className="ml-3 text-sm text-gray-600 align-middle"
    >
      No file chosen
    </span>
  </div>
</div>

                           <div className="fb lb">
                             <label className="rc" htmlFor="message">
                               Message
                             </label>
                             <textarea
                               placeholder="Message"
                               rows="3"
                               name="message"
                               id="message"
                               className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
                             ></textarea>
                           </div>
             
                           <div className="tc xf">
                               <button
  type="submit"
  className="ek jk lk gh gi hi rg ml il vc _d _l jc"
  disabled={loading}   onClick={handleSubmit}
>
  {loading ? "Please wait..." : "Submit Application"}
</button>
                
                           </div>
                         </motion.section>
                         </div>
                        
                       </div>
                     </div>
                   </div>
                 </section>
              
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Careers;
